import { getRewardCurrency } from "@/src/constants/rewardly-currencies";
import { fetchRewardCurrencyRates } from "@/src/services/api/rewardly/reward-rates.api";
import { useQuery } from "@tanstack/react-query";

const ONE_DAY_MS = 1000 * 60 * 60 * 24;


export const useRewardCurrencyRates = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["rewardCurrencyRates"],
    queryFn: fetchRewardCurrencyRates,
    staleTime: ONE_DAY_MS,
    gcTime: ONE_DAY_MS,
    retry: 1,
  });

  const getStarValue = (code: string): number =>
    data?.[code] ?? getRewardCurrency(code).starValue;

  return { getStarValue, isRatesLoading: isLoading };
};
